import React from "react";

const ContactUs = () => {
  return (
    <div id="contactus" className="contact-section-container">
      <h2 className="contact-title">Contact Us</h2>
      <div className="contact-info-container">
        <div className="contact-info-item">
          <h3>Phone</h3>
          <p>7842474013</p>
        </div>
        <div className="contact-info-item">
          <h3>Email</h3>
          <p>cafeunited08@gmail.com</p>
        </div>
        <div className="contact-info-item">
          <h3>Location</h3>
          <p>Paramamount Colony Gate No. 4</p>
        </div>
      </div>
      <div className="contact-map-container">
        <iframe
          title="Google Map"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d237.94793323284122!2d78.41518276852604!3d17.40377474652861!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb97ce37f3ba85%3A0xd5fe639036f7c669!2sCafe%20United!5e0!3m2!1sen!2sin!4v1734506615246!5m2!1sen!2sin"
          width="100%"
          height="450"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
        ></iframe>
      </div>
    </div>
  );
};

export default ContactUs;
